var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":_vm.height}},_vm._l((_vm.bannerData),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{attrs:{"src":item.imgUrl,"alt":"","width":"100%","height":"100%"},on:{"click":function($event){return _vm.toJump(item.jumpUrl)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }